import { getApiBaseUrl } from "./apiBaseUrl";

export async function uploadFile(
  file: File | Blob,
  category: string,
  entityId: string,
  kind?: string,
): Promise<{ publicUrl: string | null; key: string }> {
  const formData = new FormData();
  formData.append("category", category);
  formData.append("entityId", entityId);
  formData.append("file", file);
  if (kind) {
    formData.append("kind", kind);
  }

  const res = await fetch(`${getApiBaseUrl()}/upload`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error((body as { error?: string } | null)?.error ?? `Upload failed (${res.status})`);
  }

  return res.json();
}
